'use strict';

class UniqueValidator {
    constructor() {
        'ngInject';

        this.restrict = 'A';
        this.scope = { unique: '=' }
        this.require = 'ngModel';
    }

    link(scope, element, attrs, ctrl) {
        ctrl.$validators.unique = (modelValue, viewValue) => {
            let index = scope.unique.indexOf(viewValue);
            if(index === -1) {
                return true;
            } else {
                return false;
            }
        }
    }
}

export default angular.module('leptonApp.Unique', [])
    .directive('unique', [() => new UniqueValidator])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/directive/unique_validator/unique_validator.directive.js